module.exports = __webpack_public_path__ + "images/credit-card.e6c01fb8c4a124152c79a7158ffa8dc3.svg";